(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-register-business-partner"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.affiliate-signup');
    if (!root) return;
    var form = root.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var invalid = [];
      root.querySelectorAll('input[required]').forEach(function (input) {
        input.classList.remove('as-input--error');
        if (!input.checkValidity()) {
          invalid.push(input);
          input.classList.add('as-input--error');
        }
      });
      var pw = root.querySelector('#as-password');
      if (pw && pw.value && pw.value.length < 8) {
        invalid.push(pw);
        pw.classList.add('as-input--error');
      }
      var pwConfirm = root.querySelector('#as-password-confirm');
      if (pw && pwConfirm && pw.value !== pwConfirm.value) {
        invalid.push(pwConfirm);
        pwConfirm.classList.add('as-input--error');
      }
      if (invalid.length > 0) {
        e.preventDefault();
        invalid[0].focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
